import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '@app/services/auth.service';
import { EVENT_SCHEMA, EventTrackerInternalService } from '@app/services/event-tracker-2.service';
import { EventTrackerService, QiraEventHumanReadable } from '@app/services/event-tracker.service';
import { MenuStateService } from '@app/services/menu-state.service';
import { TabService } from '@app/services/tab.service';
import { ChatTab } from '@app/services/types';
import { ScrollContainerComponent } from '@app/components/scroll-container/scroll-container.component';
import { CloseTabButtonComponent } from '@app/chat/components/close-tab-button/close-tab-button.component';
import { TabButtonComponent } from '@app/chat/components/tab-button/tab-button.component';
import { OpenVehicleSelectionButtonComponent } from '@app/vehicle-selection/components/open-vehicle-selection-button.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-tab-navigation-mobile',
  imports: [
    CommonModule,
    TranslocoPipe,
    RouterLink,
    ScrollContainerComponent,
    TabButtonComponent,
    OpenVehicleSelectionButtonComponent,
    CloseTabButtonComponent,
    Button,
  ],

  templateUrl: './tab-navigation-mobile.component.html',
  styleUrl: './tab-navigation-mobile.component.scss',
  standalone: true,
})
export class TabNavigationMobileComponent {
  router = inject(Router);
  authService = inject(AuthService);
  menuStateService = inject(MenuStateService);
  tabService = inject(TabService);
  eventTrackerService = inject(EventTrackerService);
  eventTrackerInternal = inject(EventTrackerInternalService);

  switchTab(tab: ChatTab) {
    if (tab) this.router.navigate(['chat', tab._id]);
    else this.router.navigate(['chat']);
    this.menuStateService.toggleMobileTabNavi(false);
    this.trackUserClickTab(tab);
  }

  onTabClose() {
    this.router.navigate(['chat']);
  }

  public async trackUserClickTab(tab?: ChatTab) {
    if (!tab) return;

    // deprecated event tracking
    await this.eventTrackerService.logEvent(QiraEventHumanReadable.USER_CLICK_THREAD_TAB, {
      thread_id: tab._id,
    });

    await this.eventTrackerInternal.trackEvent(EVENT_SCHEMA.CORE_PRODUCT.UI.THREAD_TAB_CLICKED, {
      thread_id: tab._id,
    });
  }
}
